// Mock Customer entity
export const Customer = {
  async list() {
    return [
      {
        id: '1',
        first_name: 'Maria',
        last_name: 'Silva',
        email: 'maria.silva@example.com',
        phone: '+55 11 98765-4321',
        status: 'active',
        country: 'Brazil',
        city: 'São Paulo',
        created_date: '2024-01-15'
      },
      {
        id: '2',
        first_name: 'João',
        last_name: 'Santos',
        email: 'joao.santos@example.com',
        phone: '+55 21 99876-5432',
        status: 'active',
        country: 'Brazil',
        city: 'Rio de Janeiro',
        created_date: '2024-02-20'
      }
    ];
  },
  async get(id) {
    const customers = await this.list();
    return customers.find(c => c.id === id);
  },
  async update(id, data) {
    return { id, ...data };
  },
  async create(data) {
    return { id: String(Date.now()), ...data };
  }
};
